import { supabase } from '../lib/supabase';

export interface InvoiceLink {
  id: string;
  client_invoice_id: string;
  payable_invoice_id: string;
  allocated_amount: number | null;
  created_at: string;
}

export const invoiceLinkService = {
  async getByCampaign(campaignId: string): Promise<InvoiceLink[]> {
    const { data: invoices, error: invErr } = await supabase
      .from('invoices')
      .select('id')
      .eq('campaign_id', campaignId);
    if (invErr) throw invErr;

    const ids = (invoices || []).map(i => i.id);
    if (ids.length === 0) return [];

    const { data, error } = await supabase
      .from('invoice_links')
      .select('*')
      .in('client_invoice_id', ids);

    if (error) throw error;
    return data || [];
  },

  async create(clientInvoiceId: string, payableInvoiceId: string, allocatedAmount?: number): Promise<InvoiceLink> {
    const { data, error } = await supabase
      .from('invoice_links')
      .insert({
        client_invoice_id: clientInvoiceId,
        payable_invoice_id: payableInvoiceId,
        allocated_amount: allocatedAmount ?? null,
      })
      .select()
      .maybeSingle();

    if (error) throw error;
    if (!data) throw new Error('Failed to create invoice link');
    return data;
  },

  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('invoice_links')
      .delete()
      .eq('id', id);
    if (error) throw error;
  },

  async deleteByPair(clientInvoiceId: string, payableInvoiceId: string): Promise<void> {
    const { error } = await supabase
      .from('invoice_links')
      .delete()
      .eq('client_invoice_id', clientInvoiceId)
      .eq('payable_invoice_id', payableInvoiceId);
    if (error) throw error;
  },

  async autoLinkCampaign(campaignId: string): Promise<number> {
    const { data, error } = await supabase.rpc('auto_link_campaign_invoices', {
      p_campaign_id: campaignId,
    });
    if (error) throw error;
    return data || 0;
  },
};
